import styles from './link.less'; export {styles};

export interface LinkProps {
    id?: number;
    name: string;
    url: string;
    hasChildren: boolean;
    onLinksActivate: Function;
}

export default class Link extends React.PureComponent<LinkProps, null> {

    constructor(props) {
        super(props);
        this.onActivate = this.onActivate.bind(this);
    }

    onActivate(links?: number[]) {
        if (!links) {
            links = [];
        }

        links.push(this.props.id);
        this.props.onLinksActivate(links);
    }

    render() {
        return (
            <div className={styles.link}>
                {this.props.name && (
                    <div className={styles.handle}>
                        <a href={this.props.url} className={styles.name}>{this.props.name}</a>
                        {this.props.hasChildren && <div className={styles.next} onClick={() => this.onActivate()}/>}
                    </div>
                )}
            </div>
        );
    }
}
